import { Controller } from "@hotwired/stimulus"

// scegli() di NuovaDemo in pages/Piani.js: la richiesta scelta riempie organizzazione (company, altrimenti name) ed
// email; «Nessuna» le svuota.
export default class extends Controller {
  static targets = ["nome", "email"]

  scegli({ currentTarget: select }) {
    const opzione = select.selectedOptions[0]
    this.nomeTarget.value = opzione?.dataset.nome || ""
    this.emailTarget.value = opzione?.dataset.email || ""
  }
}
